// import React from "react";
// import { useSelector } from "react-redux";
// import { selectSiteNews } from "../../../AsianExchangeSrc/utils/helper/commonSelectors";




// const Marquee = ({ newsItems }) => {
  
//   const News = useSelector(selectSiteNews())
//   if(News?.length > 0){
//     return (
//       <div className="marquee-box">
//         <h4>News</h4>
//         <div className="marquee">
//           <div className="js-marquee">
//             {News?.map((item, index) => (
//               <a key={index}>
//                 <span className="text-xs">Match :- {item}</span> 
//               </a>
//             ))}
//           </div>
//         </div>
//       </div>
//     );
//   } else {
//     return null
//   }
// };

// export default Marquee;

import React from 'react'

const Marquee = () => {
  return (
    <>
      
    </>
  )
}

export default Marquee

